import { useEffect, useState } from "react";
import axios from "axios";
import { MessagesSquare, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CommunityCard() {
  const [c, setC] = useState(null);

  useEffect(() => {
    axios.get(`${API}/community`).then((r) => setC(r.data)).catch(() => setC(null));
  }, []);

  if (!c?.enabled) return null;

  return (
    <div
      className="rounded-3xl border border-linen-border shadow-soft overflow-hidden"
      style={{ background: "linear-gradient(140deg,#0F2A47 0%,#143253 70%,#1F8F8B 170%)" }}
      data-testid="mlo-community-card"
    >
      <div className="p-6">
        <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-[#A6D24A]">
          <MessagesSquare size={13} /> The partner group
        </div>
        <h3 className="mt-1 font-heading font-medium text-xl text-white">{c.label}</h3>
        {c.note && <p className="mt-1.5 text-sm text-white/75 leading-relaxed">{c.note}</p>}
        <a
          href={c.url}
          target="_blank"
          rel="noreferrer"
          data-testid="mlo-community-join"
          className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-[#A6D24A] text-[#08192F] font-semibold text-sm px-5 py-2.5 hover:brightness-105 transition-all"
        >
          Join the {c.platform_label || "group"} <ArrowRight size={14} />
        </a>
      </div>
    </div>
  );
}
